import axios from "axios";

//Set the api url
axios.defaults.baseURL = `${window.location.origin}/api`;

axios.defaults.withCredentials = true;

export { axios };
